import React from "react";
import { money } from "../lib/format";

/**
 * MetricTile — operational metric card.
 * Editorial: serif numeral, mono eyebrow label, optional caption.
 */
export function MetricTile({
  label,
  value,
  caption,
  currency,
  format = "money",
  tone = "default",
  testid,
}) {
  let display;
  if (format === "money" && typeof value === "number") {
    display = money(value, currency || "USD");
  } else if (format === "number" && typeof value === "number") {
    display = new Intl.NumberFormat("en-US").format(value);
  } else {
    display = value ?? "—";
  }

  const tones = {
    default: "text-[hsl(var(--foreground))]",
    accent: "text-[hsl(var(--accent-gold))]",
    quiet: "text-[hsl(var(--foreground-secondary))]",
    warn: "text-[hsl(var(--accent-terracotta))]",
  };

  return (
    <div className="group relative" data-testid={testid}>
      <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[hsl(var(--foreground-muted))]">
        {label}
      </div>
      <div
        className={`mt-2 font-serif text-3xl sm:text-4xl leading-none tracking-[-0.02em] ${
          tones[tone] || tones.default
        }`}
      >
        {display}
      </div>
      {caption && (
        <div className="mt-2 font-body text-xs text-[hsl(var(--foreground-secondary))]">
          {caption}
        </div>
      )}
    </div>
  );
}
